<template>
  <teacher-picker-dialog :preselect="preselect" :preselect-name="preselectName" :institution-id="institutionId" :people="assignedEmployees" :value="value" mode="assign" @input="$emit('input', $event)"
                         @update:institution="$emit('update:institution')"/>
</template>

<script lang="ts">
import Vue from 'vue';
import {Types} from 'mongoose';
import {Employee} from '@/interfaces/employee.interface';
import TeacherPickerDialog from './teacherPicker/teacherPickerDialog.vue';

/** Lehrkräfte einer Schule zuteilen with ranked suggestions (air-line distance, availability, workload); saving lives in teacherPickerDialog */
export default Vue.extend({
  components: {TeacherPickerDialog},
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    institutionId: {
      type: Object as () => Types.ObjectId,
      required: true,
    },
    assignedEmployees: {
      type: Array as () => Array<Pick<Employee, '_id' | 'firstName' | 'lastName'>>,
      required: true,
    },
    /** Optional id added to the selection on open (near views) */
    preselect: {type: String, default: ''},
    preselectName: {type: String, default: ''},
  },
});
</script>
